import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OptimizedImageByName from '../common/OptimizedImageByName';

export const FeaturesSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <section 
      className="px-6 py-10 bg-white" 
      aria-labelledby="why-choose-piika"
    >
      <h2 id="why-choose-piika" className="text-2xl font-bold mb-6 text-left text-gray-900 text-center">
        {t('flowers.features.title')}
      </h2>
      
      <div className="space-y-6">
        {[
          {
            icon: <OptimizedImageByName imageName="farmWhy" alt="Farm fresh" className="w-20 h-20 object-contain" />,
            title: t('flowers.features.farmFresh.title'),
            description: t('flowers.features.farmFresh.description')
          },
          {
            icon: <OptimizedImageByName imageName="varietyWhy" alt="Weekly variety" className="w-20 h-20 object-contain" />,
            title: t('flowers.features.weeklyVariety.title'),
            description: t('flowers.features.weeklyVariety.description')
          },
          {
            icon: <OptimizedImageByName imageName="freshWhy" alt="Always fresh" className="w-20 h-20 object-contain" />,
            title: t('flowers.features.alwaysFresh.title'),
            description: t('flowers.features.alwaysFresh.description')
          },
          {
            icon: <OptimizedImageByName imageName="giftWhy" alt="Perfect gift" className="w-20 h-20 object-contain" />,
            title: t('flowers.features.perfectGift.title'),
            description: t('flowers.features.perfectGift.description')
          }
        ].map((feature, index, array) => (
          <div 
            key={index} 
            className={`flex items-center space-x-4 py-4 pl-4 gap-1 ${
              index < array.length - 1 ? 'border-b border-gray-200' : ''
            }`}
            role="listitem"
          >
            <div className="w-20 h-20 rounded-xl flex items-center justify-center flex-shrink-0">
              {feature.icon}
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-lg text-gray-900">{feature.title}</h3>
              <p className="text-gray-600 text-base leading-relaxed">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Simple subscription button */}
      <div className="mt-8 text-center">
        <button
          onClick={() => navigate('/subscription', { 
            state: { 
              fromPage: 'features',
              serviceType: 'flower'
            } 
          })}
          className="w-full max-w-sm mx-auto py-3 px-6 bg-yellow-400 text-gray-900 rounded-lg font-medium hover:bg-yellow-500 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2"
        >
          {t('flowers.features.viewPlans')}
        </button>
      </div>
    </section>
  );
}; 